import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { resetCourseCache } from "@/lib/course";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      try {
        const { data } = await api.post("/auth/refresh");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    resetCourseCache();
    setUser(data);
    return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    resetCourseCache();
    setUser(data);
    return data;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    resetCourseCache();
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, reload: loadMe }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
